module.exports = __webpack_public_path__ + "VIPG3.png?121d63d7d1d5d41023086f9fe21415bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG3.png
// module id = 75
// module chunks = 0